/*global Wistia */
import PDFViewer from './pdf-viewer';

export default {
    init: function () {
        this.checkQueryParams();
        this.preloadPDF();
        this.bindEvents();
    },

    checkQueryParams: function () {
        const urlParams = new URLSearchParams(window.location.search);

        const targetName = urlParams.get('modal');
        const type = urlParams.get('type') ? urlParams.get('type') : targetName;
        const videoID = urlParams.get('video-id');
        const asset = urlParams.get('asset');
        const page = urlParams.get('post');
        this.openModal(targetName, type, videoID, asset, page);
    },

    handleOpenModalClick: function ($$) {
        const targetName = $$.data('target-modal');
        const type = $$.data('type');
        const videoID = $$.data('video-id');
        const asset = $$.data('asset');
        const page = $$.data('collection-id');
        this.openModal(targetName, type, videoID, asset, page);
    },

    preloadPDF: function () {
        let loadPDF = $('.pdf-modal').find('[data-load-pdf]');
        if (loadPDF.length < 1) return;
        loadPDF.each((i, pdfEl) => {
            const $pdf = $(pdfEl);
            PDFViewer.init($pdf.data('load-pdf'), $pdf);
        });
    },

    openModal: function (targetName, type, videoID, asset, page) {
        let modal = $(`[data-modal="${targetName}"]`);

        if (type === 'wistia' && typeof Wistia !== 'undefined') {
            if (Wistia.api('modal-' + videoID)) {
                Wistia.api('modal-' + videoID).play();
                //set URL param
                let refresh = window.location.protocol + '//' + window.location.host + window.location.pathname + `?modal=true&video-id=` + videoID;
                window.history.pushState({path: refresh}, '', refresh);
            }
        }

        if (type === 'collection') {
            this.collectionGoToResource(modal, page);
        }

        $(window).trigger('modal-open', modal);
        modal.addClass('open');
    },

    closeModal: function () {

        $('.modal, .innovation-modal, .slider-modal').not('.request-demo-popup').removeClass('open');
    },

    collectionGoToResource(modal, slideId) {
        let slide = modal.find(`[data-collection-id="${slideId}"]`);
        if (!slide.length) slide = modal.find(`[data-collection-id]`).first();
        let loadPDF = slide.find('[data-load-pdf]');
        let noPDFBool = slide.data('no-pdf');
        modal.find('[data-collection-id]').addClass('hidden');
        slide.removeClass('hidden');
        // check PDF
        if (!noPDFBool) {
            PDFViewer.init(loadPDF.data('load-pdf'), loadPDF, slide);
        }
        //  Check video
        if (typeof Wistia !== 'undefined') {
            $('.wistia_embed').each(function () {
                let id = $(this).attr('id');
                if (Wistia.api(id))
                    Wistia.api(id).pause();
            });
        }
        //set URL param
        let refresh = window.location.protocol + '//' + window.location.host + window.location.pathname + `?modal=collection&post=` + slideId;
        window.history.pushState({path: refresh}, '', refresh);

    },

    maybeOpenModal(videoID) {
        let triggers = $('#play-wrapper[data-target-modal], #play-wrapper[data-wistia], .shortcode-video-modal-trigger[data-target-modal]');
        if (videoID) {
            triggers = triggers.filter('[data-target-modal="' + videoID + '"]');
        }
        if (triggers.length === 0) return;
        setTimeout(() => {
            triggers.first().trigger('click');
        }, 300);
    },

    bindEvents: function () {

        let _this = this;
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('modal') && urlParams.get('modal') === 'true') {
            this.maybeOpenModal(urlParams.get('video-id'));
        }

        $('.modal--escape, .modal--overlay, .modal-image-container').click(function () {
            _this.closeModal();
        });
        $(document).on('click', '*[data-target-modal], *[data-wistia]', function (e) {

            e.preventDefault();
            _this.handleOpenModalClick($(this));
        });

        $(document).keyup(function (e) {
            if (e.keyCode === 27) {
                _this.closeModal();
            }
        });

        $('[data-target-collection-id]').on('click', function () {
            let el = $(this);
            _this.collectionGoToResource(el.parents('[data-modal]'), el.data('target-collection-id'));
        });

    },

};